"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _customProps = require("../../../../utils/customProps");

var Icon = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../components/PageGrid/atoms/Icon/Icon"));
  });
});
/**
   * MuiButton controls Dialog open state from true to false.
   * More docs and demos at https://material-ui.com/api/button/
   */

var Button = function Button(_ref) {
  var rootClass = _ref.rootClass,
      color = _ref.color,
      disableElevation = _ref.disableElevation,
      disableFocusRipple = _ref.disableFocusRipple,
      disableRipple = _ref.disableRipple,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      size = _ref.size,
      startIcon = _ref.startIcon,
      variant = _ref.variant,
      buttonText = _ref.buttonText,
      onClick = _ref.onClick;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: styles.root,
    color: color,
    disableElevation: disableElevation,
    disableFocusRipple: disableFocusRipple,
    disableRipple: disableRipple,
    endIcon: endIcon.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, /*#__PURE__*/_react.default.createElement(Icon, endIcon[0])) : null,
    fullWidth: fullWidth,
    size: size,
    startIcon: startIcon.length > 0 ? /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, /*#__PURE__*/_react.default.createElement(Icon, startIcon[0])) : null,
    variant: variant,
    onClick: onClick,
    "data-testid": "muiButton"
  }, buttonText);
};

exports.Button = Button;
var _default = Button;
exports.default = _default;
Button.propTypes = {
  /** button text */
  buttonText: _propTypes.default.string.isRequired,

  /**
   * stroyblok multiselect of css classes
   * Override or extend the styles applied to the component
   * expecting array of string ex: ['color: black', 'font-Size: 20px' ]
   * */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'default', 'inherit', 'primary', 'secondary'
   * The color of the component. It supports those theme colors that make sense for this component.
   * */
  color: function color(props, propName, componentName) {
    var validProps = ['default', 'inherit', 'primary', 'secondary'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: true | false
   * If true, no elevation is used.
   */
  disableElevation: _propTypes.default.bool,

  /**
   * mui prop: true | false
   * If true, the keyboard focus ripple will be disabled. disableRipple must also be true.
   */
  disableFocusRipple: _propTypes.default.bool,

  /**
   * mui prop: true | false
   * If true, the ripple effect will be disabled.
   * Without a ripple there is no styling for :focus-visible by default.
   * Be sure to highlight the element by applying separate styles with the focusVisibleClassName.
   */
  disableRipple: _propTypes.default.bool,

  /**
   * name of Icon uses Icon
   * Element placed after the children. renders icon
   * any icon from https://material.io/resources/icons/?style=baseline
   * */
  endIcon: function endIcon(props, propName, componentName) {
    var components = ['Icon'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * mui prop: true | false
   * If true, the button will take up the full width of its container.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * mui prop: 'small', 'medium', 'large'
   * The size of the button. small is equivalent to the dense button styling.
   * */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium', 'large'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * name of Icon uses Icon
   * Element placed before the children. renders icon
   * any icon from https://material.io/resources/icons/?style=baseline
   * */
  startIcon: function startIcon(props, propName, componentName) {
    var components = ['Icon'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /**
   * mui prop: 'text','outlined', 'contained'
   * The variant to use.
   * */
  variant: function variant(props, propName, componentName) {
    var validProps = ['text', 'outlined', 'contained'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
  /** not in storyblok passed down from parent component */
  onClick: _propTypes.default.func.isRequired
};
Button.defaultProps = {
  rootClass: [],
  color: 'secondary',
  disableElevation: false,
  disableFocusRipple: false,
  disableRipple: false,
  endIcon: [],
  fullWidth: true,
  size: 'medium',
  startIcon: [],
  variant: 'text'
};